import './public-path';
import "babel-polyfill";
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import configureStore, {history} from "./shared/store/configureStore";
import rootReducer from "./reducers";
import * as serviceWorker from './serviceWorker';
import App from './app';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import './assets/ak-cached/2h/stylesheets/modules/buttons.css';
import './assets/ak-cached/2h/stylesheets/modules/modules.css';
import './assets/ak-cached/2h/stylesheets/modules/radioButtons.css';
import './assets/ak-cached/2h/stylesheets/modules/swiper.css'
import './assets/ak-cached/2h/stylesheets/base/base.css';
import './assets/ak-cached/2h/stylesheets/base/fonts.css';
import './assets/ak-cached/2h/stylesheets/layout/grid.css';
import './assets/ak-cached/2h/stylesheets/layout/layout.css';
import './assets/ak-cached/2h/stylesheets/mobile/css/modules/buttons.css';
import './assets/ak-cached/2h/stylesheets/mobile/css/modules/modules.css';
import './assets/ak-cached/2h/stylesheets/mobile/css/base/fonts.css';
import './assets/ak-cached/2h/stylesheets/mobile/css/layout/grid.css';
import './assets/ak-cached/2h/stylesheets/mobile/css/layout/layout.css';
import './assets/ak-cached/2h/stylesheets/pages/plansPage.css';
import './assets/ak-cached/2h/stylesheets/pages/countrySelectionPage.css';
import './assets/ak-cached/2h/stylesheets/modules/arrows.css';
import './assets/ak-cached/2h/stylesheets/modules/accordion.css';
import './assets/ak-cached/2h/stylesheets/base/responsive.css';
import './assets/ak-cached/2h/stylesheets/modules/singles.css';
import './assets/ak-cached/2h/stylesheets/pages/ild.css';
import './assets/ak-cached/2h/stylesheets/modules/icons.css';
import './assets/ak-cached/2h/stylesheets/pages/featureConflict.css';
//import './assets/ak-cached/2h/stylesheets/pages/International/international.css';


const store = configureStore(rootReducer);

const persistor = persistStore(store);
console.log('__webpack_public_path__ ----', __webpack_public_path__);

render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App history={history} />
      </PersistGate>
    </Provider>, document.getElementById('app')
  );


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
